import { CartParticipantForm } from '../admins-page/carts/participant/CartParticipantForm';
import { cartServices } from 'src/services';
import { FailedToGetData, H2, Loading } from 'src/components/_commons';
import { setAlertResponse } from 'src/store';
import { typeCartsDoc, typeCartParticipant } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser, useGetIsDarkMode } from 'src/custom-hooks';
import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';

export const CartsSelfRegistrationPage = () => {
    const [cartsDoc, setCartsDoc] = useState<typeCartsDoc | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isEditInit, setIsEditInit] = useState(false);
    const [selectedParticipant, setSelectedParticipant] = useState<typeCartParticipant | null>(null);
    const isDarkMode = useGetIsDarkMode();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useGetCurrentUser();

    useEffect(() => {
        cartServices.Get().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.cartsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            const participant = response.data.cartsDoc.participants?.find(p => p.userId === user.id);
            if (participant) {
                setSelectedParticipant(participant);
                setIsEditInit(true);
                setCartsDoc({ ...response.data.cartsDoc, users: response.data.cartsDoc.users?.filter(u => u.userId === user.id) });
            } else {
                const p: typeCartParticipant = {
                    availabilities: [],
                    comments: '',
                    email: user.email,
                    hasParticipatedBefore: false,
                    isEnabled: false,
                    lastName: user.lastName,
                    name: user.name,
                    phoneNumber: user.phoneNumber,
                    priority: 3,
                    userId: user.id
                };
                setSelectedParticipant(p);
                setIsEditInit(false);
                setCartsDoc({ ...response.data.cartsDoc, users: [p]});
            }
        });
    }, []);

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!cartsDoc) {
        return <FailedToGetData />;
    }

    return (
        <div>
            <H2 title={'AUTORREGISTRO CARRITOS'} />
            <div className={`container card ${isDarkMode ? 'bg-dark text-white' : ''} py-4 mt-4`}>
                <div className={'text-center mb-4 mt-3'}>
                    <h2>
                        Solicitud para participar en los Carritos
                    </h2>
                    <p className={isDarkMode ? '' : 'text-muted'}>
                        INVITAMOS A INSCRIBIRSE (2 Timoteo 4:5 )
                    </p>
                </div>
                <CartParticipantForm
                    cartsDoc={cartsDoc}
                    isEditInit={isEditInit}
                    isSelfRegistration={true}
                    goBack={() => navigate('/')}
                    selectedParticipant={selectedParticipant}
                    setRefreshCounter={() => {}}
                    setSelectedParticipant={() => {}}
                />
            </div>
        </div>
    );
}
